import { type MCPServerInfo } from '../../types';

const SentinelOneServer: MCPServerInfo = {
  serverId: 'SENTINELONE',
  name: 'SentinelOne',
  slug: 'sentinelone',
  description:
    "SentinelOne's official MCP server (purple-mcp) for read-only queries against Purple AI, alerts, vulnerabilities, misconfigurations, inventory, and PowerQuery. No mutations are supported.",
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/Sentinel-One/purple-mcp',
    commitSha: 'latest',
    packageType: 'pip',
    packageName: 'purple-mcp'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['consoleToken', 'consoleBaseUrl'],
    properties: {
      consoleToken: {
        type: 'string',
        description:
          'SentinelOne service user token. Create one under Console → Policy & Settings → User Management → Service Users. Must be Account or Site level (not Global).',
        sensitive: true
      },
      consoleBaseUrl: {
        type: 'string',
        description:
          'SentinelOne console URL (e.g. https://console.sentinelone.net).',
        sensitive: false
      }
    }
  }
};

export default SentinelOneServer;
